import { cva } from '@/styled-system/css';

export const adornedInputRecipe = cva({
  base: {
    'backgroundColor': {
      base: 'AdornedInput.bg.default',
    },
    'cursor': 'text',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.AdornedInput.default} var(--shadow-color)',
    },
    'boxShadowColor': {
      base: 'AdornedInput.border.default',
    },
    'textStyle': 'body',
    '&.edge-autofilled': {
      backgroundColor: { base: 'AdornedInput.bg.default' },
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
    '&:has([data-c11n-component="AdornedInput.Input"] ~ button[data-c11n-component="AdornedInput.Adornment"])':
      {
        paddingInlineEnd: 0,
      },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        '&:has(input:focus-visible), &:active:not(:has(button:active, [role="button"]:active, a:active))':
          {
            backgroundColor: 'AdornedInput.bg.active',
            boxShadow:
              'inset 0 0 0 {borderWidths.AdornedInput.default} var(--shadow-color), {shadows.focus}',
            boxShadowColor: 'AdornedInput.border.active',
          },
        'backgroundColor': {
          _hover: 'AdornedInput.bg.hover',
          _active: 'AdornedInput.bg.active',
          _focus: 'AdornedInput.bg.active',
        },
        'boxShadowColor': {
          _hover: 'AdornedInput.border.hover',
          _active: 'AdornedInput.border.active',
          _focus: 'AdornedInput.border.active',
        },
        '&:is(:hover:active), &:is(:hover:focus)': {
          backgroundColor: 'AdornedInput.bg.activeHover',
        },
      },
    },
    error: {
      true: {
        'backgroundColor': {
          base: 'AdornedInput.bg.error',
        },
        'boxShadowColor': {
          base: 'AdornedInput.border.error',
        },
        '&:has(input:focus-visible), &:active:not(:has(button:active, [role="button"]:active, a:active))':
          {
            backgroundColor: 'AdornedInput.bg.errorActive',
            boxShadowColor: 'AdornedInput.border.errorActive',
          },
      },
      false: {},
    },
    fluid: {
      true: {
        display: 'flex',
        width: '100%',
      },
      false: {
        display: 'inline-flex',
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        backgroundColor: {
          base: 'AdornedInput.bg.readOnly',
        },
        boxShadowColor: 'transparent.invisible',
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'AdornedInput.sm',
        columnGap: 'AdornedInput.sm.gap.input-toAdornment',
        paddingInline: 'AdornedInput.sm.padding.horz',
      },
      md: {
        borderRadius: 'AdornedInput.md.default',
        columnGap: 'AdornedInput.md.gap.input-toAdornment',
        paddingInline: 'AdornedInput.md.padding.horz',
      },
      lg: {
        borderRadius: 'AdornedInput.lg.default',
        columnGap: 'AdornedInput.lg.gap.input-toAdornment',
        paddingInline: 'AdornedInput.lg.padding.horz',
      },
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      readOnly: true,
      css: {
        paddingInline: 'AdornedInput.sm.padding.horz-readOnly',
      },
    },
    {
      size: 'md',
      readOnly: true,
      css: {
        paddingInline: 'AdornedInput.md.padding.horz-readOnly',
      },
    },
    {
      size: 'lg',
      readOnly: true,
      css: {
        paddingInline: 'AdornedInput.lg.padding.horz-readOnly',
      },
    },
    {
      readOnly: true,
      disabled: false,
      css: {
        backgroundColor: {
          _active: 'AdornedInput.bg.readOnly',
          _focusWithin: 'AdornedInput.bg.readOnly',
          _hover: 'AdornedInput.bg.readOnly',
        },
        boxShadowColor: 'transparent.invisible',
      },
    },
    {
      error: true,
      disabled: false,
      css: {
        'backgroundColor': {
          _hover: 'AdornedInput.bg.errorHover',
          _active: 'AdornedInput.bg.errorActive',
        },
        'boxShadowColor': {
          _active: 'AdornedInput.border.errorActive',
          _hover: 'AdornedInput.border.errorHover',
        },
        '&:is(:hover:active)': {
          backgroundColor: 'AdornedInput.bg.errorActive',
        },
      },
    },
  ],
});
